<template>
    <div>
        <div class="title-lable-error">
            <span class="ml-3">The machine has been used</span>
        </div>
        <div
            class="d-flex flex-row mt-3 ml-3"
            style="color: #757575; font-size: 0.85rem"
        >
            <div>
                Hardware is currently in use. Please boot at another point or
                disabled Fixed MAC address.
            </div>
        </div>
    </div>
</template>

<script>
import base from "@/scripts/base";

export default {
    extends: base,
};
</script>